import React from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { MessageCircle } from 'lucide-react';

function WhatsAppButton() {
  const { config } = useSiteConfig();

  const handleWhatsAppClick = () => {
    const number = config?.whatsapp_number || '';
    const message = encodeURIComponent('¡Hola! Me gustaría obtener más información sobre sus productos.');
    const url = number
      ? `https://wa.me/${number}?text=${message}`
      : `https://wa.me/?text=${message}`;
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-8 right-8 z-40 bg-[#25D366] hover:bg-[#1fb855] text-white p-4 rounded-full shadow-lg transition-all hover:scale-110"
      data-testid="whatsapp-button"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
}

export default WhatsAppButton;
